$(function () {
    var $slide = $('.sec-testimonials .testimonials-carousel');

    if (!$slide.length) return

    $slide.owlCarousel({
        items: 3,
        autoplay: true,
        loop: false,
        navContainer: $('.sec-testimonials .owl-navs_inner'),
        rewind: true,
        dots: false,
        nav: true,
        navElement: 'span',
        navText: ['<i class="icon-nav_back"></i>', '<i class="icon-nav_next"></i>'],
        navSpeed: 500,
        dotsSpeed: 500,
        dragEndSpeed: 500,
        autoplaySpeed: 500,
        autoplayTimeout: 10000,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            768: {
                items: 2,
                nav: true
            },
            1200: {
                items: 3,
                nav: true
            },
        }
    });

    var $slideNavs = $('.sec-testimonials .owl-navs_inner.disabled');

    if (!$slideNavs.length) return
    $('.sec-testimonials .owl-navs').addClass('disabled');
});